import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import {
  K_COLORS_DARK_GREY,
  K_COLORS_NIGHT_GREY,
  K_COLORS_LIGHT_BLUE,
} from "constants.js";

const AngleDown = (props) => {
  const [isGlowing, setIsGlowing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const { onClick } = props;
  const styles = {
    angle: {
      fontSize: "4rem",
      transition: "1s",
      transform: isGlowing ? "translateY(20px)" : "translateY(0)",
      cursor: "pointer",
    },
  };

  const colorStyle = isHovered
    ? { color: isGlowing ? K_COLORS_LIGHT_BLUE : K_COLORS_DARK_GREY }
    : { color: isGlowing ? K_COLORS_DARK_GREY : K_COLORS_NIGHT_GREY };

  useEffect(() => {
    setTimeout(() => {
      setIsGlowing(!isGlowing);
    }, 500);
  }, [isGlowing]);

  return (
    <i
      className="fa fa-angle-down"
      style={{ ...styles.angle, ...colorStyle }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
};

AngleDown.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AngleDown;
